import { type LucideIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface TrackerSummaryButtonProps {
  label: string;
  count: number;
  onClick: () => void;
  icon?: LucideIcon;
  compact?: boolean;
  className?: string;
}

export function TrackerSummaryButton({
  label,
  count,
  onClick,
  icon: Icon,
  compact = false,
  className,
}: TrackerSummaryButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size={compact ? "sm" : "default"}
      onClick={onClick}
      className={cn(
        "h-auto gap-2 px-0 py-0 font-medium hover:bg-transparent hover:opacity-70",
        compact && "gap-1 text-xs",
        className
      )}
    >
      {Icon ? <Icon className={cn("size-4 text-muted-foreground", compact && "size-3.5")} /> : null}
      <span className={cn("text-sm", compact && "text-xs text-muted-foreground")}>{label}:</span>
      <Badge
        variant="secondary"
        className={cn("cursor-pointer", compact && "h-5 text-xs")}
      >
        {count}
      </Badge>
    </Button>
  );
}
